if (!customElements.get('products-background')) {
    class ProductsBackground extends HTMLElement {
        constructor() {
            super();
            this.selector = {
                productCards: this.querySelectorAll('.product-card-wrapper[data-product-url]'),
                modal: document.getElementById('menu-modal-box'),
                modalClose: document.getElementById('menu-modal-box-close')
            };
            this.load();
        }
        load() {
            if(this.selector.productCards.length > 0) {
                this.selector.productCards.forEach(card => {
                    card.addEventListener('click', event => {
                        event.preventDefault();
                        const productUrl = card.dataset.productUrl;
                        if(productUrl) {
                            document.body.classList.add('body-overflow');
                            this.render(productUrl);
                        }
                    })
                })
            }
            if(this.selector.modalClose) {
                this.selector.modalClose.addEventListener('click', () => {
                    document.body.classList.remove('body-overflow');
                    this.selector.modal.classList.remove('active');
                })
            }
        }
        async render(url) {
            await fetch(`${url}?section_id=product-details-box`)
            .then(result => result.text())
            .then(html => {
                this.selector.modal.querySelector('.render-content').innerHTML = html;
            })
            .catch(error => {
                console.error('TEST::', error);
            })
            .finally(async () => {
               this.selector.modal.classList.add('active');
            });
        }
    }

    customElements.define('products-background', ProductsBackground);
}